import * as DateFns from "date-fns";
import * as Pikaday from "pikaday";
import S, { DataSignal } from "s-js";
import * as Surplus from "surplus";
import { InputState } from "surplus-forms";
import "./_date.scss";

export function InputDate(props: { data: DataSignal<InputState<Date>> }) {
    const dom = <input type="text" class="datepicker" id={props.data().name} />;
    let picker = undefined as any as Pikaday;
    let pickerDate = null as Date | null;
    S.on(props.data, () => {
        const propDate = S.sample(props.data).value;
        if (!picker) initPicker(propDate);
        // Prevent infinite loop caused by updating external prop date in picker's onSelect callback
        if (!picker || pickerDate === propDate) return;

        picker.setDate(propDate);
    });

    window.requestAnimationFrame(() => {});
    return dom;

    function initPicker(initialDate: Date) {
        picker = new Pikaday({
            field: dom,
            defaultDate: initialDate,
            toString(date, format) {
                return DateFns.format(date, "EEE dd MMM yyyy");
            },
            parse(dateString, format) {
                return DateFns.parse(dateString, "EEE dd MMM yyyy", new Date());
            },
            onSelect: handleOnDateSelect,
        });
    }

    function handleOnDateSelect(date: Date) {
        const currData = S.sample(props.data);
        pickerDate = date;
        props.data({ ...currData, __v: currData.__v + 1, value: date });
    }
}
